import Login2 from './modules/login2';
import Login2024 from './modules/login2024';

$(function () {
    window.Login2 = new Login2();
    window.Login2024 = new Login2024();
});
